import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/components/ui/card';
import { Badge } from 'src/components/ui/badge';
import { Button } from 'src/components/ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface TokenHoldingsOverviewErrorProps {
  error: Error;
  onRetry: () => void;
  isRetrying: boolean;
}

export const TokenHoldingsOverviewError = ({
  error,
  onRetry,
  isRetrying,
}: TokenHoldingsOverviewErrorProps) => {
  return (
    <Card className="mx-auto w-full max-w-[1500px] rounded-lg border border-muted-50 bg-background bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] dark:border-muted-200">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium uppercase text-muted-foreground">
            Token Holdings
          </CardTitle>
          <Badge
            variant="outline"
            className="border-destructive text-destructive"
          >
            Error
          </Badge>
        </div>
      </CardHeader>

      <CardContent>
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <AlertCircle className="mb-4 h-12 w-12 text-destructive" />
          <h3 className="mb-2 text-lg font-semibold text-foreground">
            Failed to Load Token Holdings
          </h3>
          <p className="mb-6 max-w-md text-muted-foreground">
            We encountered an error while fetching token holdings for this
            address. Please try again or check if the address is valid.
          </p>
          <div className="flex gap-2">
            <Button
              onClick={onRetry}
              disabled={isRetrying}
              variant="outline"
              size="sm"
            >
              {isRetrying ? (
                <>
                  <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
                  Retrying...
                </>
              ) : (
                <>
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Try Again
                </>
              )}
            </Button>
          </div>
          {error instanceof Error && (
            <details className="mt-4 text-xs text-muted-foreground">
              <summary className="cursor-pointer hover:text-foreground">
                Error Details
              </summary>
              <pre className="mt-2 max-w-md overflow-auto rounded bg-muted p-2 text-left">
                {error.message}
              </pre>
            </details>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
